import React, { useState, useCallback } from 'react';
import { useAppDispatch } from '../../store';
import Dropdown, { DropdownOption } from '../shared/TailwindComponents/Dropdown';
import Button from '../shared/TailwindComponents/Button';
import { useTranslation } from 'react-i18next';
import { showFeedbackModal } from '../../store/actions/UserFeedbackActions';
import { attachExistingCaseToClient } from '../../store/actions/ClientActions';
import Spinner from '../shared/TailwindComponents/Spinner';

interface AttachCaseToClientProps {
  clientId: string;
  onClose: () => void;
}

const AttachCaseToClientModalContent: React.FC<AttachCaseToClientProps> = ({
  clientId,
  onClose
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [matterOptions, setMatterOptions] = useState<DropdownOption[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMatterId, setSelectedMatterId] = useState<string>('');



  const fetchCaseOptions = useCallback(async (query: string, page: number) => {

    setIsLoading(true);
    const response: any =  {} 
    setTotalPages(response.totalPages || 1);
    const new_options =  response.matters
      .map((c: any) => ({
        value: c.MatterID,
        label: c.MatterName || `Matter ${c.MatterID}`
      }));

    setMatterOptions((prev: any) => [...prev, ...new_options])
    setIsLoading(false);

    return new_options

    
  }, []);

  const handleAttach = async () => {
    if (!selectedMatterId) {
      dispatch(showFeedbackModal({
        modalType: 'warning',
        message: t('Please select a matter to attach.'),
        showModal: true,
        duration: 3000
      }));
      return;
    }
    const success = await dispatch(attachExistingCaseToClient(clientId, selectedMatterId));
    if (success) {
      dispatch(showFeedbackModal({
        modalType: 'success',
        message: t('Matter attached successfully.'),
        showModal: true,
        duration: 3000
      }));
      onClose();
    }
  };

  return (
    <div>
      <div className='px-4'>
        <p className="text-sm text-gray-700 dark:text-gray-200">
          {t("Select one of your unassigned matters to attach it to this client:")}
        </p>

        <Dropdown
          label={t("Unassigned Matters")}
          placeholder={t("Choose a Matter")}
          options={matterOptions}
          value={selectedMatterId}
          onChange={(val) => setSelectedMatterId(val as string)}
          useApi={true}
          fetchOptions={fetchCaseOptions}
          totalPages={totalPages}
          description={t("Search for unassigned matters by name")}
        />
      </div>
      <div className="flex justify-end space-x-2 mt-6 pt-6 border-t border-1 border-gray-300 px-4">
        <Button variant="neutral" size="small" onClick={onClose}>{t("Cancel")}</Button>
        <Button variant="primary" size="small" onClick={handleAttach} disabled={isLoading}>
          {isLoading ? <Spinner tone="current" size="glyph"  /> : t("Attach Matter")}
        </Button>
      </div>
    </div>
  );
};

export default AttachCaseToClientModalContent;